import type { IComponentController, IScope } from "angular";
import type { INotificationConfiguration, INotificationSubscription, ISite } from "App/Modules/Models";
import { NotificationType } from "App/Modules/Models";
import type { Duration } from "moment";
import { duration } from "moment";

enum NotificationLevel {
    Critical,
    Warning,
    Information,
}

export default class EditARCIssueSubscriptionsComponentController implements IComponentController {
    public static $inject: string[] = ["$scope"];

    public notificationConfiguration: INotificationConfiguration;
    public site: ISite;

    public subscriptions: INotificationSubscription[];
    public types: any[];

    public notificationTypes: any[] = [
        {
            type: NotificationType.SystemFailure,
            level: NotificationLevel.Critical,
            enabled: false,
        },
        {
            type: NotificationType.ConnectionFailure,
            level: NotificationLevel.Critical,
            enabled: false,
        },
        {
            type: NotificationType.VideoQualityFailure,
            level: NotificationLevel.Critical,
            enabled: false,
        },
        {
            type: NotificationType.Tampering,
            level: NotificationLevel.Critical,
            enabled: false,
        },
        {
            type: NotificationType.ConnectionDegraded,
            level: NotificationLevel.Warning,
            enabled: false,
        },
    ];

    public disabled: boolean;

    public durations: Array<{ value: Duration; text: string }> = [
        { value: duration(1, "seconds"), text: "Gui.Common.Immediate" },
        {
            value: duration(5, "minutes"),
            text: duration(5, "minutes").humanize(),
        },
        {
            value: duration(15, "minutes"),
            text: duration(15, "minutes").humanize(),
        },
        {
            value: duration(30, "minutes"),
            text: duration(30, "minutes").humanize(),
        },
        { value: duration(1, "hours"), text: duration(1, "hours").humanize() },
        { value: duration(23, "hours").add(59, "minutes").add(59, "seconds"), text: duration(1, "days").humanize() },
    ];
    public currentDuration: { value: Duration; text: string };

    constructor(private readonly $scope: IScope) {}

    public $onInit() {
        const unsub = this.$scope.$watch("$ctrl.subscriptions", (subscriptions: INotificationSubscription[]) => {
            if (!subscriptions) {
                return;
            }

            this.notificationTypes.forEach((notificationType) => {
                notificationType.selected = subscriptions.some((sub) => sub.notificationType === notificationType.type);
            });
            unsub();
        });

        this.currentDuration = {
            text: duration(this.notificationConfiguration.timeUntilNotification).humanize(),
            value: duration(this.notificationConfiguration.timeUntilNotification),
        };

        this.$scope.$watch("$ctrl.currentDuration.value", (newValue: Duration, oldValue: Duration) => {
            if (newValue.asMilliseconds() !== oldValue.asMilliseconds()) {
                this.notificationConfiguration.timeUntilNotification = (newValue as any).format("hh:mm:ss", {
                    trim: false,
                });
            }
        });
    }

    public onInput() {
        this.subscriptions = [];
        this.selectedNotifications().forEach((type) => {
            this.subscriptions.push({
                notificationType: type,
            } as INotificationSubscription);
        });
    }

    public areNotificationsSelected(): boolean {
        return this.notificationTypes.some((type) => type.selected);
    }

    public selectedNotifications(): number[] {
        return this.notificationTypes.filter((type) => type.selected).map((type) => type.type);
    }

    public typesCritical(): any[] {
        return this.notificationTypes.filter((type) => type.level === NotificationLevel.Critical);
    }

    public typesWarning(): any[] {
        return this.notificationTypes.filter((type) => type.level === NotificationLevel.Warning);
    }

    public typesInfo(): any[] {
        return this.notificationTypes.filter((type) => type.level === NotificationLevel.Information);
    }

    public toggleShowMore(event: any): void {
        event.target.closest(".show-more").classList.toggle("show-more--active");
    }
}
